import { useEffect, useState } from "react";
import { WifiOff } from "lucide-react";
import { ERROR_UI } from "@/constants/testIds";

/**
 * Non-intrusive banner that appears when the browser reports offline status.
 */
export const NetworkStatusBanner = () => {
  const [online, setOnline] = useState(
    typeof navigator !== "undefined" ? navigator.onLine : true,
  );

  useEffect(() => {
    const goOnline = () => setOnline(true);
    const goOffline = () => setOnline(false);
    window.addEventListener("online", goOnline);
    window.addEventListener("offline", goOffline);
    return () => {
      window.removeEventListener("online", goOnline);
      window.removeEventListener("offline", goOffline);
    };
  }, []);

  if (online) return null;

  return (
    <div
      data-testid={ERROR_UI.offlineBanner}
      role="status"
      aria-live="polite"
      className="sticky top-16 z-40 border-b border-amber-200 bg-amber-50 px-4 py-2 text-center text-xs font-medium text-amber-900"
    >
      <span className="inline-flex items-center gap-2">
        <WifiOff className="h-3.5 w-3.5" strokeWidth={1.75} />
        لا يوجد اتصال بالإنترنت — بعض الميزات قد لا تعمل حتى تستعيد الاتصال.
      </span>
    </div>
  );
};
